module.exports = __webpack_public_path__ + "media/images/play-icon-white-de888ceb.png";